import Image from "next/future/image";

import photo8 from "assets/careers/photo-reel/8@2x.png";
import photo6 from "assets/careers/photo-reel/6@2x.png";
import photo7 from "assets/careers/photo-reel/7@2x.png";
import photo3 from "assets/careers/photo-reel/3@2x.png";
import photo10 from "assets/careers/photo-reel/10@2x.png";
import photo5 from "assets/careers/photo-reel/5@2x.png";
import photo4 from "assets/careers/photo-reel/4@2x.png";
import photo1 from "assets/careers/photo-reel/1@2x.png";
import photo9 from "assets/careers/photo-reel/9@2x.png";

import styles from "./TeamPhotos.module.css";

const TeamPhotos = () => (
  <div className={styles.teamPhotosPlaceholder}>
    <div className={styles.teamPhotosWrapper}>
      {[photo8, photo6, photo7, photo3, photo10, photo5, photo4, photo1, photo9].map((photo, index) => (
        <Image key={index} src={photo} alt="" className={styles.photo} />
      ))}
    </div>
  </div>
);

export default TeamPhotos;
